import axios from "axios";

export default {
	async all() {
		return await axios.get("/categories");
	},

};